import { Directive, ElementRef, HostListener, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { runtimeEventManager } from '@wm/core';
import { BaseComponent } from '@wms/app/components';
import { toUpper } from 'lodash-es';

@Directive({
  selector: '[wmsWidgetHelp]',
  standalone: true
})
export class WmsWidgetHelpDirective extends BaseComponent {

  @Input() wmsWidgetHelp!: string;
  @Input() activeWidget!: any;
  @HostListener('mouseenter') onMouseEnter = () => {
    this.handleHover(true);

  }
  @HostListener('mouseleave') onMouseLeave = () => {
    this.handleHover(false);
  }
  @HostListener('dragstart') onDragStart = () => {
    this.handleHover(false);
  }
  constructor(private el: ElementRef, private viewContainerRef: ViewContainerRef) {
    super();
  }

  onHelpIconClick = (e: Event) => {
    let property = this.wmsWidgetHelp;
    let infoObj,
      infoText = '',
      infoName = '',
      mobileInfoText = '';
    if (property) {
      if ((this.activeWidget.widgetType === 'wm-prefab' || this.activeWidget.widgetType === 'wmx-component' || this.activeWidget.widgetType === 'wm-custom-widget') && this.activeWidget.widgetProps[property]) {
        infoText = this.activeWidget.widgetProps[property].helpText;
        infoName = this.activeWidget.widgetProps[property].displayName;
      }
      var labelKey = this.activeWidget.widgetProps?.[property]?.labelKey || this.activeWidget.widgetProps?.[property]?.label;

      if (this.projectService.isMobileApplicationType()) {
        mobileInfoText = this.locale['MESSAGE_HELP_PROPERTY_MOBILE_APPLICATION_' + toUpper(this.activeWidget.widgetType) + '_' + toUpper(property)]
          || this.locale['MESSAGE_HELP_PROPERTY_MOBILE_APPLICATION_' + toUpper(property)];
        if (property === 'hint') {
          mobileInfoText = this.locale['MESSAGE_HELP_PROPERTY_HINT_MOBILE'];
        }
        if (property === 'accessible') {
          mobileInfoText = this.locale['MESSAGE_HELP_PROPERTY_ACCESSIBLE_MOBILE'];
        }
        if (property === 'accessibilitylabel') {
          mobileInfoText = this.locale['MESSAGE_HELP_PROPERTY_ACCESSIBLE_LABEL_MOBILE'];
        }
          if (property === 'accessibilityrole') {
          mobileInfoText = this.locale['MESSAGE_HELP_PROPERTY_ACCESSIBLE_ROLE_MOBILE'];
        }
      }
      infoObj = {
        type: 'property',
        propertyInfo: {
          name: infoName || property,
          info: infoText || mobileInfoText || this.locale['MESSAGE_HELP_PROPERTY_' + toUpper(this.activeWidget.widgetType) + '_' + toUpper(property)] ||
            (labelKey && this.locale['MESSAGE_HELP_PROPERTY_' + toUpper(labelKey)]) ||
            this.locale['MESSAGE_HELP_PROPERTY_' + toUpper(property)] || this.locale['MESSAGE_HELP_PROPERTY_' + toUpper(property)]
        }
      };
      runtimeEventManager.emit('wms:show-widget-help', infoObj);
    } else {
      infoObj = {
        type: 'widget',
        widgetInfo: this.activeWidget
      };
      runtimeEventManager.emit('wms:show-widget-help', infoObj);
    }
    e.stopPropagation();
  }

  handleHover(mouseOver: boolean) {
    let elementDom: HTMLElement = this.el.nativeElement;
    let id = this.wmsWidgetHelp;
    if (mouseOver) {
      let $helpNode = document.createElement('span');
      $helpNode.innerHTML = '?';
      $helpNode.setAttribute('class', 'wms-help-icon');
      $helpNode.setAttribute('id', 'help-icon-' + id);
      if (!elementDom.querySelector('.wms-help-icon')) {
        if (this.wmsWidgetHelp) {
          elementDom.querySelector('.property-label')?.append($helpNode);
        } else {
          elementDom.prepend($helpNode)
        }
      }
      let helpDomNode = elementDom.querySelector('.wms-help-icon');
      helpDomNode?.addEventListener('click', this.onHelpIconClick)
    } else {
      let helpDomNode = elementDom.querySelector('.wms-help-icon');
      helpDomNode?.remove();
    }
  }
}
